export default __webpack_public_path__ + "static/media/about03.c26c2547.png";